import CtaLink from './ui/cta-link'
import { cx } from '@/utils/strings'
import { locales, localizedPath, useLocale } from '@/utils/locale.ts'
import { router, usePage } from '@inertiajs/react'

export default function SelectLocale({ otherLocales = [] }): JSX.Element {
  const { url } = usePage()
  const { currentLocale } = useLocale(url)

  return (
    <div>
      <label htmlFor="footer-language" className="absolute left-[-9000px]">
        Language
      </label>
      <div className="relative">
        <select
          className="w-auto h-10 pl-4 pr-8 bg-transparent border border-secondary-100 rounded-4xl appearance-none cursor-pointer
            outline-transparent focus-visible:outline-hidden hover:border-secondary-200 focus-visible:border focus-visible:border-primaryBlue 
            dark:border-secondary-400  dark:bg-secondary-900 dark:text-secondary-50
            "
          id="footer-language"
          defaultValue={currentLocale}
          onChange={(event) => {
            router.visit(localizedPath(url, event.target.value))
          }}
        >
          {locales.map((locale) => (
            <option key={locale.slug} value={locale.slug}>
              {locale.label}
            </option>
          ))}
        </select>
        <span className="font-bwi block absolute top-0 right-4 pointer-events-none text-[0.625rem] leading-[2.5rem]">
          &#xe92d;
        </span>
      </div>
    </div>
  )
}
